var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { ref: "searchbox", on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6" },
              [
                _c("c-select", {
                  attrs: {
                    codeGroupCd: "RELATED_LAWS_CD",
                    type: "search",
                    itemText: "codeName",
                    itemValue: "code",
                    name: "relatedLawsCd",
                    label: "LBL0010245",
                  },
                  model: {
                    value: _vm.searchParam.relatedLawsCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "relatedLawsCd", $$v)
                    },
                    expression: "searchParam.relatedLawsCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "인허가 종류 목록",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            gridHeight: _vm.grid.height,
            columnSetting: false,
            isExcelDown: false,
            isFullScreen: false,
            selection: _vm.popupParam.type,
            rowKey: "limLicenseKindId",
          },
          on: { rowDblclick: _vm.rowDblclick },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    attrs: { label: "LBLSEARCH", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                  _c("c-btn", {
                    attrs: { label: "LBLSELECT", icon: "check" },
                    on: { btnClicked: _vm.select },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }